import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faTimes } from '@fortawesome/free-solid-svg-icons';
import '@medprompt/shared/src/common/modals.css';
import './ViewersWarningModal.css';

/**
 * Email forwarding guidance modal. Dismissal is tracked in sessionStorage as
 * `medprompt_emailForwardWarningShown`: a JSON string array of documentIds.
 */
const EmailForwardWarningModal = ({ onDismiss }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container modal-animated viewers-warning-modal">
        <div className="modal-header">
          <div className="modal-title">
            <FontAwesomeIcon icon={faEnvelope} className="warning-icon" />
            <h2>Document received by email</h2>
          </div>
          <button type="button" className="close-button" onClick={onDismiss}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="modal-content">
          <p className="warning-message">
            This document was received via email forwarding. Only forward <strong>clinical correspondence</strong>{' '}
            (for example letters and clinic communications). Do not forward <strong>direct emails from patients</strong>.
          </p>
        </div>

        <div className="modal-actions">
          <button type="button" className="dismiss-button" onClick={onDismiss}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailForwardWarningModal;
